import { Journey, Traveler } from '@flysas-tech/book-value-stream-models';
import { Object, Static, String, Optional, Array, Record } from '@sinclair/typebox';

import { FareRules } from '../../sas-domain/fareRules';

export const FareRulesQueryParams = Object({
  fareFamilyName: String(),
});
export type FareRulesQueryParams = Static<typeof FareRulesQueryParams>;

export const FareRulesResponse = Object({
  fareRules: Optional(FareRules),
});
export type FareRulesResponse = Static<typeof FareRulesResponse>;

export const TicketRulesRequest = Object({
  categories: Array(String()),
  officeId: String(),
  cepId: Optional(String()),
  travelers: Array(Traveler),
  journeys: Array(Journey),
});
export type TicketRulesRequest = Static<typeof TicketRulesRequest>;

export const TicketRulesReponse = Object({
  rules: Record(String(), Array(String())),
});
export type TicketRulesReponse = Static<typeof TicketRulesReponse>;
